import { isValidEmail } from './inlineRegistration.js';
import { Fetch } from './helpers.js';

const UTM_KEYS = ['utm_campaign', 'utm_content', 'utm_medium', 'utm_source', 'utm_term'];
const NAME_MAX_LENGTH = 100;
const MESSAGE_MAX_LENGTH = 1000;

// Форма «Tell us what you ship» на странице Enterprise: отправка через общий /api/feedback/
const initForm = (card) => {
  const form = card.querySelector('form');
  const success = card.querySelector('.enterprise-request__success');
  const submit = form.querySelector('[type="submit"]');
  const submitError = form.querySelector('.enterprise-request__submit-error');
  const { name, company, email, message, privacy } = form.elements;
  const errors = form.dataset;
  let submitting = false;

  const setError = (input, text = '') => {
    const field = input.closest('[data-field]');
    field.classList.toggle('is-invalid', Boolean(text));
    input.setAttribute('aria-invalid', String(Boolean(text)));
    field.querySelector('.enterprise-request__error').textContent = text;
  };
  const required = (input, tooLong) => {
    const value = input.value.trim();
    const error = !value ? errors.errorRequired : (tooLong?.(input.value) ? errors.errorNameLength : '');
    setError(input, error);
    return !error;
  };
  const validators = {
    name: () => required(name, (value) => value.length > NAME_MAX_LENGTH),
    company: () => required(company, (value) => value.length > NAME_MAX_LENGTH),
    email: () => {
      const value = email.value.trim();
      const error = !value ? errors.errorRequired : (isValidEmail(value) ? '' : errors.errorEmail);
      setError(email, error);
      return !error;
    },
    message: () => {
      const error = message.value.length > MESSAGE_MAX_LENGTH ? errors.errorMessageLength : '';
      setError(message, error);
      return !error;
    },
    privacy: () => {
      const error = privacy.checked ? '' : errors.errorPrivacy;
      setError(privacy, error);
      return !error;
    }
  };

  [name, company, email, message].forEach((input) => {
    input.addEventListener('input', validators[input.name]);
    input.addEventListener('blur', validators[input.name]);
  });

  privacy.addEventListener('change', validators.privacy);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    // Повторная отправка при двойном клике игнорируется
    if (submitting) return;

    const valid = Object.values(validators).map((validate) => validate()).every(Boolean);
    if (!valid) {
      form.querySelector('[aria-invalid="true"]')?.focus();
      return;
    }

    const payload = {
      name: name.value.trim(),
      company: company.value.trim(),
      email: email.value.trim(),
      message: message.value,
      language: form.elements.language.value,
      page_id: form.elements.page_id.value,
      component_id: form.elements.component_id.value
    };
    const params = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach((key) => {
      if (params.get(key)) payload[key] = params.get(key);
    });

    submitting = true;
    submit.disabled = true;
    form.setAttribute('aria-busy', 'true');
    submitError.hidden = true;
    try {
      const response = await Fetch(form.action, {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      if (!response.ok) {
        if (response.status === 400) {
          const details = await response.json();
          [name, company, email, message].forEach((input) => {
            if (!details[input.name]?.length) return;
            if (!validators[input.name]()) return;

            setError(input, errors.errorServer);
          });
        }
        throw new Error(`Feedback request failed: ${response.status}`);
      }

      // В аналитику уходит только факт заявки, без персональных данных
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'generate_lead', form_id: 'enterprise' });
      form.hidden = true;
      success.hidden = false;
      success.focus();
    } catch (error) {
      // Введённые данные остаются в форме
      submitError.hidden = false;
      console.error(error);
    } finally {
      submitting = false;
      submit.disabled = false;
      form.removeAttribute('aria-busy');
    }
  });
};

export default function enterpriseRequest () {
  document.querySelectorAll('[data-enterprise-request]').forEach(initForm);
}
